import type { ReactNode } from 'react';

import { Toast } from '@base-ui/react';

import { ToastViewport } from '~/components';
import { toastManager } from '~/utils/toast';

type Props = {
  children: ReactNode;
};

export const ToastProvider = ({ children }: Props) => {
  return (
    <Toast.Provider timeout={5000} toastManager={toastManager}>
      {children}
      <Toast.Portal>
        <ToastViewport />
      </Toast.Portal>
    </Toast.Provider>
  );
};
